import { useEffect, useState } from 'react';

import { UseCounter } from '../interfaces';
import { UseState } from '../types';

export const useCounter: () => UseCounter = (): UseCounter => {
  const [counter, setCounter]: UseState<number> = useState<number>(0);

  const startCounter: (value: number) => void = (value: number): void => {
    setCounter(value);
  };

  useEffect(
    (): void => {
      if (counter > 0) {
        setTimeout((): void => setCounter((seconds: number): number => seconds - 1), 1000);
      }
    },
    [counter]
  );

  return {
    startCounter,
    counter,
  };
};
